import React, { useState } from "react";
import { auth } from "../firebase";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";

const SettingsModal = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword.trim() !== confirmPassword.trim()) {
      setError("🚫 New password and confirmation do not match.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      setError("🚫 User not authenticated.");
      return;
    }

    try {
      // 1. Reauthenticate user using Firebase Auth to verify if the old password is correct
      const credential = EmailAuthProvider.credential(user.email, oldPassword.trim());
      try {
        await reauthenticateWithCredential(user, credential);
      } catch (authErr) {
        console.error("Reauthentication failed:", authErr);
        if (authErr.code === "auth/wrong-password" || authErr.code === "auth/invalid-credential") {
          setError("🚫 Old password is incorrect.");
        } else {
          setError("🚫 Reauthentication failed: " + authErr.message);
        }
        return;
      }

      // 2. Update password in Firebase Authentication
      await updatePassword(user, newPassword.trim());

      setSuccess("✅ Password updated successfully!");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Failed to update password:", err);
      setError("🚫 Failed to update password: " + err.message);
    }
  };

  const handleModalClose = () => {
    setError("");
    setSuccess("");
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const EyeToggleIcon = ({ visible, toggle }) =>
    visible ? (
      <FaEyeSlash onClick={toggle} className="eye-toggle-icon" />
    ) : (
      <FaEye onClick={toggle} className="eye-toggle-icon" />
    );

  return (
    <div
      className="modal fade"
      id="changePasswordModal"
      tabIndex="-1"
      aria-labelledby="changePasswordModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 shadow border-0">
          <div className="modal-header border-0">
            <h5 className="modal-title w-100 text-center text-primary fw-bold">
              Change Password
            </h5>
            <button
              type="button"
              className="btn-close position-absolute end-0 top-0 m-3"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleModalClose}
            ></button>
          </div>

          <div className="modal-body px-4 pb-4">
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <form onSubmit={handlePasswordUpdate}>
              <div className="mb-3 position-relative">
                <label className="form-label fw-semibold">Old Password</label>
                <input
                  type={showOld ? "text" : "password"}
                  className="form-control rounded-3 pe-5"
                  placeholder="Enter old password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
                <EyeToggleIcon visible={showOld} toggle={() => setShowOld(!showOld)} />
              </div>

              <div className="mb-3 position-relative">
                <label className="form-label fw-semibold">New Password</label>
                <input
                  type={showNew ? "text" : "password"}
                  className="form-control rounded-3 pe-5"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <EyeToggleIcon visible={showNew} toggle={() => setShowNew(!showNew)} />
              </div>

              <div className="mb-4 position-relative">
                <label className="form-label fw-semibold">Confirm Password</label>
                <input
                  type={showConfirm ? "text" : "password"}
                  className="form-control rounded-3 pe-5"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <EyeToggleIcon
                  visible={showConfirm}
                  toggle={() => setShowConfirm(!showConfirm)}
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary py-2">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>
        {`
          .eye-toggle-icon {
            position: absolute;
            right: 15px;
            top: 43px;
            color: #888;
            cursor: pointer;
            z-index: 5;
          }
        `}
      </style>
    </div>
  );
};

export default SettingsModal;
